The icon image to indicate profile exists.
